var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeaker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.3536 22.6464C36.3674 14.1668 31.126 5.66026 22.6464 3.6464C14.1669 1.63254 5.66027 6.87402 3.64641 15.3536C1.63256 23.8331 6.87404 32.3397 15.3536 34.3536C23.8331 36.3674 32.3397 31.1259 34.3536 22.6464Z",
    fill: "#556DF2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3524 22.9376C21.299 23.3766 21.2833 23.8086 21.1638 24.2556C20.9737 24.8926 20.4763 25.2822 19.9397 25.2665C19.6851 25.2727 19.3269 25.1172 19.0856 24.9138L16.272 22.621H14.7045C13.9494 22.621 13.4395 22.1042 13.3366 21.2527C13.1904 20.2049 13.2038 18.312 13.3366 17.2429C13.4395 16.5046 13.9494 15.9226 14.7045 15.9226H16.272L19.0275 13.6691C19.2687 13.4641 19.6851 13.2708 19.9397 13.2763C20.4763 13.2606 20.9737 13.651 21.1638 14.2872C21.2699 14.6941 21.299 15.1669 21.3524 15.606C21.4805 16.6326 21.4805 21.911 21.3524 22.9376Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2246 15.205C24.9427 16.2413 25.3738 17.6316 25.3738 19.1789C25.3738 20.7263 24.9427 22.1158 24.2246 23.1521",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeaker);
export default __webpack_public_path__ + "static/media/speaker.70c6a3576bce77fe99e411bddd0f17ea.svg";
export { ForwardRef as ReactComponent };